import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { GEO_INFO } from 'actions/geoInfo';

const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${GEO_INFO}_LOADING`:
      return state.merge({ loading: true, error: null });
    case GEO_INFO:
      return state.merge({
        loading: false,
        data: action.payload,
        error: null,
      });
    case `${GEO_INFO}_ERROR`:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    default:
      return state;
  }
};
